import { Link } from "react-router-dom";
import React from "react";
import "./Modal.css";
import { AiOutlineClose } from "react-icons/ai";

const Modal = ({ showModal }) => {
  return (
    <div className="modal">
      <div className="close-modal">
        <AiOutlineClose className="cm" onClick={showModal} />
      </div>

      <div className="cart">
        <Link to="/Portfolio/speakhabla">Speakhabla Bela</Link>
      </div>

      <div className="cart">
        <Link to="/Portfolio/intellikid">IntelliKid</Link>
      </div>

      <div className="cart">
        <Link to="/Portfolio/fitfun">Fitfun smartwatch</Link>
      </div>

      <div className="cart">
        <Link to="/Portfolio/loblaw-grocery-selfcheckout">selfcheckout</Link>
      </div>
    </div>
  );
};

export default Modal;
